import React from 'react'
import styled from 'styled-components'
import { TabPane, Button } from 'reactstrap'
import { StickyContainer, Sticky } from 'react-sticky'
import get from 'lodash/get'

import moment from '../../../../lib/moment.js'
import { Statusbar } from '../../status-bar'
import RemarkRow from './remark-row'
import { Searchbar } from '../../search-bar'
import { HourRow } from './hour-row'
import { HourRowMobile } from './hour-row-mobile'
import { MaximumRow } from './maximum-row'
import { DataRow } from './data-row'
import { DataRowMobile } from './data-row-mobile'
import { StatusRow } from './status-row'
import { Leave } from '../../form/show-leave'
import { Compensate } from '../../form/show-compensate'
import { Holiday } from '../../form/show-holiday'
import InfoModal from '../my-timesheet/info-modal'
import RemarkModal from '../my-timesheet/remark-modal'
import LegendsModal from '../my-timesheet/legends-modal'
import * as timesheetHelper from '../../helpers/timesheet'
import * as CONSTANTS from '../../constants'

export const MyTimesheet = class extends React.Component {
  state={
    showInfomation: false,
    showRemark: false,
    showLegends: false,
    showDetail: false,
    showLocation: false,
    showApprover: false,
    searchTimesheet: '',
    isOpen: false,
  }

  showRequestDetail = (dataType, data) => {
    if (dataType === CONSTANTS.HOLIDAY || dataType === CONSTANTS.COMPENSATE) {
      this.setState({ dataType, data: this.changeDataFormat(dataType, data) })
    } else {
      this.setState({ dataType: CONSTANTS.LEAVE, data: this.changeDataFormat(dataType, data) })
    }
  }

  changeDataFormat = (dataType, data) => {
    switch (dataType) {
      case CONSTANTS.HOLIDAY: {
        const holiday = {}
        holiday.holiday_name = get(data, 'description')
        return holiday
      }
      case CONSTANTS.COMPENSATE: {
        const users = get(this.props, 'timesheets.users', [])
        const projects = get(this.props, 'timesheets.projects', [])
        const compensates = []
        data.map(d => {
          const compensate = {}
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const project = timesheetHelper.findUserData(get(d, 'project_id'), projects)
          compensate.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          compensate.project = project ? `${project.project_code} - ${project.name}` : '-'
          compensate.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          compensate.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          compensate.working_time = get(d, 'compensate_time')
          compensate.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          compensate.status = get(d, 'status')
          compensate.remark_request_user = get(d, 'remark_request_user')
          compensate.remark_approver = get(d, 'remark_approver')
          compensate.remark_cancel = get(d, 'remark_cancel')
          compensates.push(compensate)
          return d
        })
        return compensates
      }
      default: {
        const users = get(this.props, 'timesheets.users', [])
        const leaveTypes = get(this.props, 'leaveTypes', [])
        const leaves = []

        data.map(d => {
          const user = timesheetHelper.findUserData(get(d, 'user_id'), users)
          const approver = timesheetHelper.findUserData(get(d, 'approver_id'), users)
          const leave_type = timesheetHelper.findUserData(get(d, 'leave_type_id'), leaveTypes)
          const leave = {}
          leave.name = user ? `${user.first_name} ${user.last_name} (${user.nick_name})` : '-'
          leave.start_date = moment(get(d, 'start_date')).format('DD/MM/YYYY')
          leave.end_date = moment(get(d, 'end_date')).format('DD/MM/YYYY')
          leave.leave_type = get(leave_type, 'name')
          leave.leave_time = get(d, 'leave_time')
          leave.created = moment(get(d, 'created')).format('DD/MM/YYYY')
          leave.days = get(d, 'days')
          leave.approver = approver ? `${approver.first_name} ${approver.last_name} (${approver.nick_name})` : '-'
          leave.status = get(d, 'status')
          leave.attachment_url = get(d, 'attachment_url')
          leave.remark_request_user = get(d, 'remark_request_user')
          leave.remark_approver = get(d, 'remark_approver')
          leave.remark_hr = get(d, 'remark_hr')
          leave.remark_cancel = get(d, 'remark_cancel')
          leaves.push(leave)
          return d
        })
        return leaves
      }
    }
  }

  handleClickCell = (dataType, data) => {
    this.setState({ showDetail: !this.state.showDetail })
    if (!this.state.showDetail) {
      this.showRequestDetail(dataType, data)
    } else {
      this.setState({ dataType: null, data: {} })
    }
  }

  openInfo = () => {
    this.setState({ showInfomation: !this.state.showInfomation })
  }

  openRemark = () => {
    this.setState({ showRemark: !this.state.showRemark })
  }

  openLegends = () => {
    this.setState({ showLegends: !this.state.showLegends })
  }

  render() {
    const clickEdit = get(this.props, 'clickEdit')
    const saveMyTimesheet = get(this.props, 'saveMyTimesheet')
    const clickCancel = get(this.props, 'clickCancel')
    const can_edit = get(this.props, 'myTimesheet.can_edit')
    const windowWidth = window.innerWidth
    const hiring_date = get(this.props, 'authData.user.hiring_date')
    const last_effective_date = get(this.props, 'authData.user.last_effective_date')
    const selectedDate = get(this.props, 'selectedDate')
    const isBeforeHiringDate = moment(selectedDate).isBefore(hiring_date, 'months')
    const isAfterLastEffectiveDate = moment(selectedDate).isAfter(last_effective_date, 'months')

    return (
      <TabPane tabId={ 1 }>
        <Content>
          <Leave
            showDetail={ this.state.dataType === CONSTANTS.LEAVE }
            handleDetail={ this.handleClickCell }
            data={ this.state.data }
          />
          <Compensate
            showDetail={ this.state.dataType === CONSTANTS.COMPENSATE }
            handleDetail={ this.handleClickCell }
            data={ this.state.data }
          />
          <Holiday
            showDetail={ this.state.dataType === CONSTANTS.HOLIDAY }
            handleDetail={ this.handleClickCell }
            { ...this.state.data }
          />
          {/* timesheet mobile */}
          { windowWidth <= 700 &&
          <InfoModal
            myTimesheet={ get(this.props, 'myTimesheet') }
            toggle={ this.openInfo }
            open={ this.state.showInfomation }
          /> }
          { windowWidth <= 700 &&
          <RemarkModal
            timesheets={ get(this.props, 'timesheets') }
            myTimesheet={ get(this.props, 'myTimesheet') }
            toggle={ this.openRemark }
            open={ this.state.showRemark }
          /> }
          { windowWidth <= 700 &&
          <LegendsModal
            toggle={ this.openLegends }
            open={ this.state.showLegends }
          /> }
          {/* timesheet mobile */}
          <StickyContainer className="container relative">
            { windowWidth > 700 && <Statusbar { ...this.props } /> }
            { windowWidth > 700 && <RemarkRow { ...this.props } /> }
            <div
              className="gap tall"
            >
              <Sticky relative={ true }>
                {({ style }) => (
                  <Div style={ style } >
                    <Searchbar
                      { ...this.props }
                      searchTimesheet={ this.state.searchTimesheet }
                      handleChangeSearch={ (e) => this.setState({ searchTimesheet: e }) }
                      openInfo={ this.openInfo }
                      openRemark={ this.openRemark }
                      openLegends={ this.openLegends }
                    />
                    { windowWidth > 700 && <MaximumRow { ...this.props } /> }
                    { windowWidth > 700 && <HourRow { ...this.props } /> }
                    {/* timesheet mobile */}
                    { windowWidth <= 700 && <HourRowMobile { ...this.props } /> }
                    {/* timesheet mobile */}
                  </Div>
                )}
              </Sticky>
              { windowWidth > 700 &&
              <DataRow
                { ...this.props }
                searchTimesheet={ this.state.searchTimesheet }
                handleClickCell={ this.handleClickCell }
              /> }
              {/* timesheet mobile */}
              { windowWidth <= 700 &&
              <ContentCol>
                <DataRowMobile
                  { ...this.props }
                  approverKey={ this.state.approverKey }
                  locationKey={ this.state.locationKey }
                  taskKey={ this.state.taskKey }
                  showLocation={ this.state.showLocation }
                  showApprover={ this.state.showApprover }
                  handleLocation={ (locationKey, taskKey) => this.setState({
                    showLocation: !this.state.showLocation,
                    locationKey,
                    taskKey,
                  }) }
                  handleApprover={ (approverKey) => this.setState({
                    showApprover: !this.state.showApprover,
                    approverKey,
                  }) }
                  handleClickCell={ this.handleClickCell }
                />
                <ButtonContent>
                  { !get(this.props, 'isEdit') &&
                  <EditButton
                    disabled={ !can_edit || isBeforeHiringDate || isAfterLastEffectiveDate }
                    onClick={ () => clickEdit() }
                  >Edit</EditButton>
                  }
                  { get(this.props, 'isEdit') &&
                  <GroupButton>
                    <SaveButton
                      onClick={ () => saveMyTimesheet() }
                    >Save</SaveButton>
                    <OtherButton
                      onClick={ () => clickCancel() }
                    >Cancel</OtherButton>
                  </GroupButton>
                  }
                </ButtonContent>
              </ContentCol> }
              {/* timesheet mobile */}
              { windowWidth > 700 && <StatusRow /> }
            </div>
          </StickyContainer>
        </Content>
      </TabPane>
    )
  }
}

const Content = styled.div`
  height: calc(100vh - 120px);
  overflow-y: scroll;
  @media (max-width: 575.98px) {
    padding-bottom: 60px ;
    height: 100vh;
  }
  @media (max-width: 767.98px) {
    padding-bottom: 60px ;
    height: 100vh;
  }
  .container {
    height: calc(100vh - 125px);
    background: #EEEEEE;
    max-width: 100% ;
  }
  .gap.tall {
    height: 100%;
  }
  .container.relative {
    overflow-y: auto;
    margin: 0px;
    padding: 0px;
  }
`
const ContentCol = styled.div`
  @media (max-width: 575.98px) {
    height: 90%;
    overflow-x: hidden;
  }
  @media (max-width: 767.98px) {
    height: 90%;
    overflow-x: hidden;
  }
`
const Div = styled.div`
  height: 40px;
  top: 120px !important;
  z-index: 2 !important;
  background: #EEEEEE;
  @media (max-width: 575.98px) {
    height: 70px;
    top: 90px !important;
  }
  @media (max-width: 767.98px) {
    height: 70px;
    top: 90px !important;
  }
`
const ButtonContent = styled.div`
  background-color: #ffffff;
  height: 80px;
  width: 100%;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
  margin-bottom: 15%;
  @media (min-width: 768px) {
    display:none;
  }
  @media (min-width: 992px) {
      display:none;
  }
  @media (min-width: 1200px) {
    display:none;
  }
`
const GroupButton = styled.div`
  background-color: #ffffff;
  width: 90%;
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  font-family: 'Gotham-Bold' !important;
  font-size: 12px;
`
const EditButton = styled(Button)`
  background-color: #5CB85C;
  height: 40px;
  width: 90%;
  border: none;
`
const OtherButton = styled(Button)`
  background-color: #D44B49;
  height: 100%;
  width: 50%;
  border: none;
`
const SaveButton = styled(Button)`
  background-color: #5CB85C;
  height: 100%;
  width: 50%;
  margin-right: 5%;
  border: none;
`



// WEBPACK FOOTER //
// ./src/components/timesheet/tab-content/my-timesheet/index.js